// A money figure that may leave usage out (REQ-017): the figure, and when the line used a model
// without a price, a "partial" marker whose title and accessible name say which models' usage the
// figure excludes — by display name, never by id (figures.ts `unpricedTitle`). `null` is "—": every
// model the line used is unpriced, and no figure is shown at all. One primitive for every money cell
// of the Usage screen, so no surface shows a partial sum as a whole one.
import { Money } from "../../primitives/table";
import { unpricedTitle } from "./figures";

export function PartialMoney({ micro, unpricedModels }: { micro: number | null; unpricedModels: readonly string[] }) {
  if (micro === null) return <>—</>;
  const title = unpricedTitle(unpricedModels);
  return (
    <>
      <Money micro={micro} />
      {title && (
        <>
          {" "}
          <span class="chip chip-grey" title={title} aria-label={title}>
            partial
          </span>
        </>
      )}
    </>
  );
}
